  import React, { useState, useEffect } from "react";
  import { db } from "../../pagini/Firebase";
  import { collection, setDoc, doc, query, getDocs, where, updateDoc} from "firebase/firestore";
  import { getAuth } from "firebase/auth";
  import { format } from "date-fns"; 
  import { getStorage, ref, uploadBytes, getDownloadURL, listAll } from "firebase/storage";
  import { Timestamp } from "firebase/firestore";


  const getProfilUtilizator = async (email) => {
    const q = query(collection(db, "Utilizatori"), where("email", "==", email));
    const querySnapshot = await getDocs(q);
    if (!querySnapshot.empty) {
      return querySnapshot.docs[0].data();
    } else {
      console.log("Utilizatorul nu a fost găsit în Firestore");
      return null;
    }
  };

  const Actiuni = ({ beneficiar }) => {
    const [nume, setNume] = useState("");
    const [prenume, setPrenume] = useState("");
    const [cnp, setCnp] = useState("");
    const [domiciliu, setDomiciliu] = useState("");
    const [dataNastere, setDataNastere] = useState("");
    const [descriere, setDescriere] = useState("");
    const [dosar, setDosar] = useState("");
    const [subDosar, setSubDosar] = useState("");
    const [listaSubDosare, setListaSubDosare] = useState([]);
    const [locatie, setLocatie] = useState("");
    const [judet, setJudet] = useState(""); 
    const [dataOra, setDataOra] = useState(
  new Date().toLocaleString("ro-RO", {
    dateStyle: "full",
    timeStyle: "short",
  })
);
const JUDETE = [
  "Alba",
  "Arad",
  "Argeș",
  "Bacău",
  "Bihor",
  "Bistrița-Năsăud",
  "Botoșani",
  "Brașov",
  "Brăila",
  "Sector 1",
  "Sector 2",
  "Sector 3",
  "Sector 4",
  "Sector 5",
  "Sector 6",
  "Buzău",
  "Caraș-Severin",
  "Călărași",
  "Cluj",
  "Constanța",
  "Covasna",
  "Dâmbovița",
  "Dolj",
  "Galați",
  "Giurgiu",
  "Gorj",
  "Harghita",
  "Hunedoara",
  "Ialomița",
  "Iași",
  "Ilfov",
  "Maramureș",
  "Mehedinți",
  "Mureș",
  "Neamț",
  "Olt",
  "Prahova",
  "Satu Mare",
  "Sălaj",
  "Sibiu",
  "Suceava",
  "Teleorman",
  "Timiș",
  "Tulcea",
  "Vaslui",
  "Vâlcea",
  "Vrancea",
];
    const [fisier, setFisier] = useState(null);
    const [tipActiune, setTipActiune] = useState("");

    const storage = getStorage();

    // La schimbarea dosarului, listăm subdosarele din Storage:
    useEffect(() => {
      if (!dosar || !cnp) {
        setListaSubDosare([]);
        setSubDosar("");
        return;
      }

      const dosarPath = `${cnp}/${dosar}/`;

      const listSubFolders = async () => {
        try {
          const listRef = ref(storage, dosarPath);
          const res = await listAll(listRef);

          const subFoldersNames = res.prefixes.map(prefixRef => {
            const parts = prefixRef.fullPath.split("/");
            return parts[parts.length - 1];
          });

          setListaSubDosare(subFoldersNames);
          setSubDosar("");
        } catch (error) {
          console.error("Eroare la listarea subdosarelor:", error);
          setListaSubDosare([]);
          setSubDosar("");
        }
      };

      listSubFolders();
    }, [dosar, cnp, storage]);

    // Upload fișier ținând cont și de subdosar
    const handleFileUpload = async () => {
      if (!fisier || !cnp || !dosar) {
        alert("Selectează un fișier și completează CNP și tipul de dosar.");
        return null;
      }

      try {
  const folderPath = subDosar ? `${cnp}/${dosar}/${subDosar}` : `${cnp}/${dosar}`;
        const storageRef = ref(storage, `${folderPath}/${fisier.name}`);

        await uploadBytes(storageRef, fisier);
        const url = await getDownloadURL(storageRef);
        console.log("📁 Fișier încărcat:", url);

        return url;
      } catch (error) {
        console.error("❌ Eroare la încărcare fișier:", error);
        alert("Eroare la încărcarea fișierului.");
        return null;
      }
    };

    // Salvare acțiune în Firestore
    const handleSaveToFirestore = async () => {
      if (!dosar || !descriere) {
        alert("Completează toate câmpurile obligatorii.");
        return;
      }

      const auth = getAuth();
      const user = auth.currentUser;

      if (!user || !user.email) {
        alert("Trebuie să fii autentificat pentru a salva acțiunea.");
        return;
      }

      try {
        const profilUtilizator = await getProfilUtilizator(user.email);
        if (!profilUtilizator) {
          alert("Profilul utilizatorului nu a fost găsit.");
          return;
        }

        const now = new Date();
        const docId = format(now, "yyyy-MM-dd_HH-mm-ss");

        let linkFisier = null;
        if (fisier) {
          linkFisier = await handleFileUpload();
          if (!linkFisier) return;
        }

        const interventieData = {
          nume,
          prenume,
          cnp,
          data_nastere: dataNastere,
          domiciliu,
          dosar,
          subDosar: subDosar || null,
          tipActiune,
          descriere,
          locatie,
           judet,
  data_ora: Timestamp.now(),        
  utilizator_email: user.email,
          utilizator_nume: profilUtilizator.nume || "",
          utilizator_prenume: profilUtilizator.prenume || "",
          utilizator_institutie: profilUtilizator.institutie || "",
          utilizator_functie: profilUtilizator.functie || "",
  timestamp: Timestamp.now(),        fisier_url: linkFisier || null,
        };

        await setDoc(doc(db, "ActiuniBeneficiari", cnp, "actiuni", docId), interventieData);

 // 2️⃣ Actualizăm documentul beneficiarului cu ultima locație
    const beneficiarRef = doc(db, "Beneficiari", cnp);
    if (judet) {
      await updateDoc(beneficiarRef, {
        ultimaLocatie: {
          judet: judet,
        },
        ultimaActiuneLa: Timestamp.now(),
      });
    }



        alert("✅ Acțiunea a fost salvată cu succes în baza de date.");
        setDescriere("");
        setFisier(null);
        setSubDosar("");
      } catch (error) {
        console.error("❌ Eroare la salvarea acțiunii:", error);
        alert("Eroare la salvarea acțiunii. Vezi consola pentru detalii.");
      }
    };

    // Populăm datele beneficiarului
    useEffect(() => {
      if (!beneficiar) return;
      setNume(beneficiar.nume || "");
      setPrenume(beneficiar.prenume || "");
      setCnp(beneficiar.cnp || "");
      setDescriere(beneficiar.setDescriere || "");
      setDomiciliu(
        `Strada ${beneficiar.Strada || "-"}, Nr ${beneficiar.Numar || "-"}, Oraș ${beneficiar.Oras || "-"}, Comuna ${beneficiar.Comuna || "-"}, Sat ${beneficiar.Sat || "-"}, Jud ${beneficiar.Judet || "-"}, Țara ${beneficiar.Tara || "-"}`
      );
      setDataNastere(beneficiar.data_nasterii || "");
    }, [beneficiar]);

    // Actualizăm data/ora în timp real
    useEffect(() => {
      const interval = setInterval(() => {
        const now = new Date();
        setDataOra(
          now.toLocaleString("ro-RO", {
            dateStyle: "full",
            timeStyle: "short",
          })
        );
      }, 1000);
      return () => clearInterval(interval);
    }, []);

    // Autentificare utilizator și profil
    useEffect(() => {
      const auth = getAuth();
      const user = auth.currentUser;
      if (user && user.email) {
        getProfilUtilizator(user.email).then(() => {});
      }
    }, []);

    if (!beneficiar) return <p>Se încarcă detaliile beneficiarului...</p>;

    return (
      <div className="max-w-3xl py-8 px-4 bg-white rounded shadow">
        <h2 className="text-2xl font-bold mb-4">📄 Adaugare acțiune</h2>
<p className="text-sm text-gray-500 mb-2">
  🕒 {typeof dataOra === "string" ? dataOra : dataOra.toString()}
</p>

        <div className="mt-4">
          <label className="block font-medium">Tip acțiune</label>
          <input
            type="text"
            value={tipActiune}
            onChange={(e) => setTipActiune(e.target.value)}
            placeholder="Introduceți tipul acțiunii"
            className="w-full p-2 border rounded"
          />
        </div>

        <div className="mt-4">
          <label className="block font-medium">Locație acțiune</label>
          <input
            type="text"
            value={locatie}
            onChange={(e) => setLocatie(e.target.value)}
            placeholder="Introduceți locația manual"
            className="w-full p-2 border rounded"
          />
        </div>
<div className="mt-4">
  <label className="block font-medium">Județ acțiune</label>
  <select
    value={judet}
    onChange={(e) => setJudet(e.target.value)}
    className="w-full border p-2 rounded"
  >
    <option value="">-- Selectează județ --</option>
    {JUDETE.map((j) => (
      <option key={j} value={j}>
        {j}
      </option>
    ))}
  </select>
</div>
        <div className="mt-4">
          <label className="font-medium">Dosar *</label>
          <select
            value={dosar}
            onChange={(e) => setDosar(e.target.value)}
            className="w-full border p-2 rounded"
          >
            <option value="">-- Selectează --</option>
            <option value="dosar_social">Social</option>
            <option value="dosar_psihologic">Psihologic</option>
            <option value="dosar_angajari">Angajări</option>
            <option value="dosar_financiar">Financiar</option>
            <option value="dosar_juridic">Juridic</option>
            <option value="dosar_medical">Medical</option>
          </select>
        </div>

        {listaSubDosare.length > 0 && (
          <div className="mt-4">
            <label className="font-medium">Subdosar (alege unul)</label>
            <select
              value={subDosar}
              onChange={(e) => setSubDosar(e.target.value)}
              className="w-full border p-2 rounded"
            >
              <option value="">-- Selectează subdosar --</option>
              {listaSubDosare.map((sd) => (
                <option key={sd} value={sd}>
                  {sd}
                </option>
              ))}
            </select>
          </div>
        )}

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginTop: "16px",
            maxWidth: "800px",
          }}
        >
          <label htmlFor="descriere" style={{ marginBottom: "4px" }}>
            📝 Descriere acțiune *
          </label>
          <textarea
            id="descriere"
            rows={6}
            value={descriere}
            onChange={(e) => setDescriere(e.target.value)}
            style={{
              width: "100%",
              padding: "8px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              fontSize: "14px",
              resize: "vertical",
            }}
            placeholder="Scrie aici descrierea intervenției..."
          />
        </div>

<div className="mt-4">
  <label className="block font-medium">📎 Încarcă fișier sau fă o poză</label>
  <input
    type="file"
    accept="image/*"       // permite doar imagini
    // capture="environment"  // scoate asta pentru a avea meniul pe mobil
    onChange={(e) => setFisier(e.target.files[0])}
    className="w-full border p-2 rounded"
  />
</div>


        <button
          onClick={handleSaveToFirestore}
          className="mt-6 w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700"
        >
          💾 Adaugă Acțiunea
        </button>
      </div>
    );
  };

  export default Actiuni;
